export default __webpack_public_path__ + "static/media/imageOne.4db859ec.jpg";